import { useTranslation } from 'react-i18next'
import { Badge } from '../ui/badge'

/** The GDPR retention projection of a document or a contact (spec
 * 2026-10-03-02, lot 3). Absent state: nothing applies, nothing shown. */
export function RetentionBadge({
    state,
    until,
    testId = 'retention-badge',
}: {
    state?: string | null
    until?: string | null
    testId?: string
}) {
    const { t, i18n } = useTranslation('data-protection')
    if (!state) return null
    const date = until ? new Date(until).toLocaleDateString(i18n.language) : null
    const variant =
        state === 'due' ? 'destructive' : state === 'held' ? 'info' : state === 'undefined' ? 'warning' : 'secondary'
    const label =
        state === 'running' && date
            ? t('retention.kept_until', { date })
            : state === 'due' && date
              ? t('retention.due_since', { date })
              : t(`retention.state.${state}`)
    return (
        <Badge variant={variant} data-testid={testId} data-state={state} title={t('retention.title')}>
            {label}
        </Badge>
    )
}

/** The "restricted" badge of a document under a GDPR restriction (lot 2). */
export function RestrictedBadge({ testId = 'restricted-badge' }: { testId?: string }) {
    const { t } = useTranslation('data-protection')
    return (
        <Badge variant="warning" data-testid={testId} title={t('restricted.tooltip')}>
            {t('restricted.badge')}
        </Badge>
    )
}
